import React from 'react';
import Button from '../UI/Button';

export default function FormNavigation({ onPrevious, onNext, isFirstStep, isLastStep, canProceed = true }) {
	return (
		<div className="flex items-center justify-between mt-4">
			<Button variant="ghost" onClick={onPrevious} disabled={isFirstStep}>
				Previous
			</Button>
			<Button onClick={onNext} disabled={!canProceed}>
				{isLastStep ? 'Finish' : 'Next'}
			</Button>
		</div>
	);
}


